var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',_vm._g(_vm._b({staticClass:"row",attrs:{"align":_vm.align == 'center' ? 'middle' : _vm.align,"gutter":_vm.gutter,"justify":_vm.justify,"type":_vm.type}},'a-row',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }